import {create} from 'zustand'
import {devtools} from 'zustand/middleware'

import {IDictState, IDictActions} from './dict.type'
import { getCourses, getPrograms } from './dict.actions'


export const initialStateDict: IDictState = {
    error: null,
    isLoading: false,

    courseList: [],
    programList: [],
}

/** Хранилище - Справочники */
export const useDict = create<IDictState & IDictActions>()(devtools((set) => ({
    ...initialStateDict,

    clearDict: () => {set(initialStateDict)},

    actionGetCourses: async () => {
        set({isLoading: true})

        const res = await getCourses()
        if (res.status !== 200) set({ error: {type: res.status === 500 ? 'error' : 'warning', message: res.message} })

        if (res.message === 'OK') {
            set({error: null})
            set({courseList: res.data})
        }

        set({isLoading: false})
    },

    actionGetPrograms: async (courseID: number) => {
        set({isLoading: true})

        const res = await getPrograms(courseID)
        if (res.status !== 200) set({ error: {type: res.status === 500 ? 'error' : 'warning', message: res.message} })

        if (res.message === 'OK') {
            set({error: null})
            set({programList: res.data})
        }

        set({isLoading: false})
    },
}), {name: 'dictState'}))